import clickOk from '../click_ok.json';
import numbersPracticeInstructionStart from '../ran_numbers_practice_instruction_start.json';
import numbersItemOne from '../ran_numbers_seven.json';
import numbersItemTwo from '../ran_numbers_nine.json';
import numbersItemThree from '../ran_numbers_four.json';
import numbersItemFour from '../ran_numbers_one.json';
import numbersItemFive from '../ran_numbers_six.json';
import numbersPracticeInstructionGeneral from '../ran_numbers_practice_instruction_general.json';
import numbersPracticeReadyInstruction from '../ran_numbers_practice_ready_instruction.json';
import RAN_AUDIO_INSTRUCTIONS from '../../ran/ranConstants';

const RAN_CAPTIONS = {
    [RAN_AUDIO_INSTRUCTIONS.numbers.practiceInstructionStart]: numbersPracticeInstructionStart,
    [RAN_AUDIO_INSTRUCTIONS.numbers.autoplayInstructions[0]]: numbersItemOne,
    [RAN_AUDIO_INSTRUCTIONS.numbers.autoplayInstructions[1]]: numbersItemTwo,
    [RAN_AUDIO_INSTRUCTIONS.numbers.autoplayInstructions[2]]: numbersItemThree,
    [RAN_AUDIO_INSTRUCTIONS.numbers.autoplayInstructions[3]]: numbersItemFour,
    [RAN_AUDIO_INSTRUCTIONS.numbers.autoplayInstructions[4]]: numbersItemFive,
    [RAN_AUDIO_INSTRUCTIONS.numbers.practiceInstructionGeneral]:numbersPracticeInstructionGeneral,
    [RAN_AUDIO_INSTRUCTIONS.numbers.practiceReadyInstruction]:numbersPracticeReadyInstruction,
    [RAN_AUDIO_INSTRUCTIONS.clickOk]: clickOk,
};

export default RAN_CAPTIONS;
